<template>
    <div class="tags" ref="tagsContainer">
        <ul class="tags-list" ref="tagsList">
            <el-popover
                placement="bottom"
                width="120"
                trigger="manual"
                :ref="`popover-${index}`"
                v-for="(item, index) in tagsList"
                :key="index + '-' + item.title"
            >
                <div class="popover-menu">
                    <div class="popover-item" @click.stop="closeOther(index, item)">
                        <i class="el-icon-close"></i>
                        <span>{{ $t('common.closeOther') }}</span>
                    </div>
                    <div class="popover-item" @click.stop="closeAll(index, item)">
                        <i class="el-icon-circle-close"></i>
                        <span>{{ $t('common.closeAll') }}</span>
                    </div>
                </div>
                <li
                    @contextmenu.prevent
                    slot="reference"
                    class="tags-li"
                    :class="{ active: isActive(item.path) }"
                    @mouseover="mouseuptag(item)"
                    @mouseout="mouseouttag(item)"
                    @mousedown="mouseoutright($event, index)"
                >
                    <router-link :to="item.path" class="tags-li-title">
                        <i v-if="item.icon" :class="item.icon" class="tags-icon"></i>
                        {{ getTagTitle(item) }}
                    </router-link>
                    <span 
                        class="tags-li-icon" 
                        @click="closeTags(index)" 
                        v-show="item.isdel && item.title != '首页'"
                    >
                        <i class="el-icon-close"></i>
                    </span>
                </li>
            </el-popover>
        </ul>
        <!-- 滚动控制按钮 -->
        <div class="tags-scroll-btn" v-if="showScrollBtn">
            <div class="scroll-btn-left" @click="scrollLeft" :title="$t('common.scrollLeft')">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="scroll-btn-right" @click="scrollRight" :title="$t('common.scrollRight')">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
import bus from './bus';
export default {
    data() {
        return {
            tagsList: [
                {
                    isdel: true,
                    name: undefined,
                    path: '/indexpage',
                    title: '首页',
                    icon: 'el-icon-s-home',
                    code_id: '102'
                }
            ],
            tagIndex: 0,
            scrollPosition: 0
        };
    },

    methods: {
        // 获取标签标题，优先使用国际化翻译
        getTagTitle(item) {
            // 优先使用 code_id 进行翻译
            if (item.code_id) {
                const translated = this.$t(`navMenu.${item.code_id}`);
                // 如果翻译存在且不等于键名本身，则使用翻译
                if (translated && !translated.startsWith('navMenu.')) {
                    return translated;
                }
            }
            // 如果没有code_id或没有翻译，使用原始title
            return item.title;
        },
        isActive(path) {
            return path === this.$route.fullPath;
        },
        mouseuptag(item) {
            item.isdel = true;
        },
        mouseouttag(item) {
            if (item.path == this.$route.fullPath) {
                return;
            }
            item.isdel = false;
        },
        mouseoutright(event, index) {
            if (event.button == 2) {
                // 先关闭所有其他标签的右键菜单
                this.closeAllPopovers();
                
                this.$nextTick(() => {
                    this.tagIndex = index;
                    const popoverRef = this.$refs[`popover-${index}`];
                    if (popoverRef && popoverRef[0]) {
                        popoverRef[0].doShow();
                    }
                });
            }
        },
        // 关闭所有右键菜单
        closeAllPopovers() {
            this.tagsList.forEach((item, idx) => {
                const popoverRef = this.$refs[`popover-${idx}`];
                if (popoverRef && popoverRef[0]) {
                    popoverRef[0].doClose();
                }
            });
        },
        // 滚动控制
        scrollLeft() {
            const container = this.$refs.tagsList;
            if (container) {
                this.scrollPosition = Math.max(0, this.scrollPosition - 200);
                container.style.transform = `translateX(-${this.scrollPosition}px)`;
            }
        },
        scrollRight() {
            const container = this.$refs.tagsList;
            if (container) {
                const maxScroll = container.scrollWidth - container.offsetWidth;
                this.scrollPosition = Math.min(maxScroll, this.scrollPosition + 200);
                container.style.transform = `translateX(-${this.scrollPosition}px)`;
            }
        },
        // 滚动到最右侧（显示最新标签）
        scrollToEnd() {
            const container = this.$refs.tagsList;
            if (container) {
                const maxScroll = container.scrollWidth - container.offsetWidth;
                if (maxScroll > 0) {
                    this.scrollPosition = maxScroll;
                    container.style.transform = `translateX(-${this.scrollPosition}px)`;
                }
            }
        },

        // 关闭单个标签
        closeTags(index) {
            const delItem = this.tagsList.splice(index, 1)[0];
            const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
            if (item) {
                if (item.path !== this.$route.fullPath) {
                    this.$router.push(item.path).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            throw err;
                        }
                    });
                }
            } else {
                if (this.$route.fullPath !== '/indexpage') {
                    this.$router.push('/indexpage').catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            throw err;
                        }
                    });
                }
            }
            this.tagIndex = 0;
            sessionStorage.setItem('tagsList', JSON.stringify(this.tagsList));
        },
        // 关闭全部标签
        closeAll(index) {
            this.tagsList = [
                {
                    isdel: true,
                    name: undefined,
                    path: '/indexpage',
                    title: '首页',
                    icon: 'el-icon-s-home'
                }
            ];
            const popoverRef = this.$refs[`popover-${index}`];
            if (popoverRef && popoverRef[0]) {
                popoverRef[0].doClose();
            }
            this.$router.push('/indexpage');
            this.tagIndex = 0;
            this.scrollPosition = 0;
            const container = this.$refs.tagsList;
            if (container) {
                container.style.transform = 'translateX(0px)';
            }
            sessionStorage.setItem('tagsList', JSON.stringify(this.tagsList));
        },
        // 关闭其他标签
        closeOther(index, items) {
            var tag = {
                isdel: true,
                name: undefined,
                path: '/indexpage',
                title: '首页',
                icon: 'el-icon-s-home'
            };
            if (index == '0') {
                this.tagsList = [
                    {
                        isdel: true,
                        name: undefined,
                        path: '/indexpage',
                        title: '首页',
                        icon: 'el-icon-s-home'
                    }
                ];
            } else {
                const curItem = this.tagsList.filter(item => {
                    return item.path === items.path;
                });
                this.tagsList = curItem;
                this.tagsList.unshift(tag);
            }
            const popoverRef = this.$refs[`popover-${this.tagIndex}`];
            if (popoverRef && popoverRef[0]) {
                popoverRef[0].doClose();
            }
            this.tagIndex = 0;
            this.scrollPosition = 0;
            const container = this.$refs.tagsList;
            if (container) {
                container.style.transform = 'translateX(0px)';
            }
            sessionStorage.setItem('tagsList', JSON.stringify(this.tagsList));
            this.$router.push(items.path);
        },
        // 设置标签
        setTags(route) {
            this.tagsList.map(item => {
                return (item.isdel = false);
            });
            
            // 首先尝试精确匹配 fullPath
            let isExist = this.tagsList.some(item => {
                return item.path === route.fullPath;
            });
            
            // 如果精确匹配失败，尝试只匹配路径部分（忽略查询参数）
            if (!isExist) {
                const basePath = route.path; // 不包含查询参数的基础路径
                isExist = this.tagsList.some(item => {
                    // 从 item.path 中提取基础路径进行比较
                    const itemBasePath = item.path.split('?')[0];
                    return itemBasePath === basePath;
                });
            }

            if (!isExist) {
                //选择不一样的tag
                // if (this.tagsList.length >= 8) {
                // this.tagsList.shift();

                //     this.$confirm('请关闭一个页面在打开', '提示', {
                //         type: 'warning'
                //     }).then(res => {});
                // } else {
                // }
                this.tagsList.push({
                    title: route.meta.title,
                    path: route.fullPath,
                    name: route.matched[1] ? route.matched[1].components.default.name : undefined,
                    isdel: true,
                    code_id: route.meta.code_id || ''
                });
                // 添加新标签后，自动滚动到最右侧
                this.$nextTick(() => {
                    this.scrollToEnd();
                });
            } else {
                // 选择已有的tag
                let index = this.tagsList.findIndex(item => {
                    // 先尝试精确匹配
                    if (item.path === route.fullPath) {
                        return true;
                    }
                    // 再尝试基础路径匹配
                    const itemBasePath = item.path.split('?')[0];
                    const routeBasePath = route.path;
                    return itemBasePath === routeBasePath;
                });
                
                if (index !== -1) {
                    // 如果找到匹配的标签，更新其路径为当前完整路径并激活
                    this.tagsList[index].path = route.fullPath;
                    this.tagsList[index].isdel = true;
                    
                    // 如果当前路由与标签路径不一致，则导航到该标签对应的路径
                    if (this.$route.fullPath !== route.fullPath) {
                        this.$router.push(route.fullPath).catch(err => {
                            // 避免重复导航错误
                            if (err.name !== 'NavigationDuplicated') {
                                throw err;
                            }
                        });
                    }
                }
            }
            bus.$emit('tags', this.tagsList);
            sessionStorage.setItem('tagsList', JSON.stringify(this.tagsList));
        },
        handleTags(command) {
            command === 'other' ? this.closeOther() : this.closeAll();
        }
    },
    computed: {
        showTags() {
            return this.tagsList.length > 0;
        },
        showScrollBtn() {
            return this.tagsList.length > 5;
        }
    },
    watch: {
        $route(newValue, oldValue) {
            this.setTags(newValue);
        },
        // 监听语言切换，强制刷新标签显示
        '$i18n.locale'() {
            this.$forceUpdate();
        }
    },
    created() {
        document.addEventListener('click', e => {
            if (this.tagIndex >= 0 && this.$refs[`popover-${this.tagIndex}`]) {
                const popoverRef = this.$refs[`popover-${this.tagIndex}`];
                if (popoverRef && popoverRef[0]) {
                    popoverRef[0].doClose();
                }
                this.tagIndex = 0;
            }
        });

        this.setTags(this.$route);
        // 监听关闭当前页面的标签页
        bus.$on('close_current_tags', () => {
            for (let i = 0, len = this.tagsList.length; i < len; i++) {
                const item = this.tagsList[i];
                if (item.path === this.$route.fullPath) {
                    if (i < len - 1) {
                        this.$router.push(this.tagsList[i + 1].path);
                    } else if (i > 0) {
                        this.$router.push(this.tagsList[i - 1].path);
                    } else {
                        this.$router.push('/indexpage');
                    }
                    this.tagsList.splice(i, 1);
                    break;
                }
            }
        });
    }
};
</script>

<style scoped lang="scss">
.tags {
    position: relative;
    height: 44px;
    overflow: hidden;
    background: linear-gradient(to bottom, #ffffff 0%, #f5f7fa 100%);
    padding: 0 120px 0 10px;
    box-shadow: 0 2px 8px rgba(0, 132, 255, 0.08);
    margin-left: 10px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid #e4e7ed;
}

.tags-list {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    transition: transform 0.3s ease;
    white-space: nowrap;
}

.tags-li {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    margin: 0 4px;
    vertical-align: middle;
    color: #606266;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    transition: all 0.3s ease;
    position: relative;
    flex-shrink: 0;
    
    &:hover:not(.active) {
        background: linear-gradient(135deg, #f0f9ff 0%, #e0f2ff 100%);
        border-color: #0084ff;
        color: #0084ff;
        transform: translateY(-2px);
        box-shadow: 0 2px 8px rgba(0, 132, 255, 0.15);
    }
    
    &.active {
        background: linear-gradient(135deg, #0084ff 0%, #40a9ff 100%);
        border-color: #0084ff;
        color: #fff;
        box-shadow: 0 2px 12px rgba(0, 132, 255, 0.3);
        
        .tags-li-title {
            color: #fff;
        }
        
        .tags-li-icon {
            color: #fff;
            
            &:hover {
                background: rgba(255, 255, 255, 0.2);
            }
        }
    }
}

.tags-li-title {
    display: flex;
    align-items: center;
    color: #606266;
    text-decoration: none;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    .tags-icon {
        margin-right: 6px;
        font-size: 14px;
    }
}

.tags-li-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    border-radius: 50%;
    font-size: 12px;
    color: #909399;
    transition: all 0.2s ease;
    
    &:hover {
        background: #f56c6c;
        color: #fff;
        transform: scale(1.1);
    }
}

// 滚动按钮样式
.tags-scroll-btn {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    background: linear-gradient(to left, #ffffff 0%, #f5f7fa 100%);
    padding: 0 8px;
    z-index: 10;
    
    .scroll-btn-left,
    .scroll-btn-right {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #606266;
        border-radius: 4px;
        transition: all 0.3s ease;
        margin: 0 2px;
        
        &:hover {
            background: #0084ff;
            color: #fff;
            box-shadow: 0 2px 8px rgba(0, 132, 255, 0.3);
        }
        
        i {
            font-size: 14px;
        }
    }
}

// 右键菜单样式
.popover-menu {
    padding: 4px 0;
    
    .popover-item {
        padding: 8px 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #606266;
        transition: all 0.2s ease;
        border-radius: 4px;
        margin: 0 4px;
        
        i {
            margin-right: 8px;
            font-size: 14px;
        }
        
        &:hover {
            background: linear-gradient(135deg, #f0f9ff 0%, #e0f2ff 100%);
            color: #0084ff;
            
            i {
                color: #0084ff;
            }
        }
    }
}
</style>

<style>
.el-popover {
    width: 140px !important;
    min-width: 140px !important;
    padding: 6px 0 !important;
    border-radius: 6px !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid #e4e7ed !important;
}
</style>
